// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Yxzt","label":"CategoryService_label___YRAD","location":"CategoryService_location__rB5CU"};